import { action, observable } from 'mobx'
import { toStream } from '@/utils/mobx-util'
import { share } from 'rxjs/operators'

/**
 * Basic toggle view model.
 */
export class Toggle {
  /**
   * Whether the toggle is enabled.
   */
  @observable accessor isEnabled = false

  /**
   * Enabled state as an observable. Emits on subscribe.
   */
  isEnabled$ = toStream(() => this.isEnabled, true).pipe(share())

  /**
   * Constructor.
   *
   * @param enabled
   */
  constructor(enabled = false) {
    this.isEnabled = enabled
  }

  /**
   * Toggles the enabled state.
   */
  @action.bound
  toggle() {
    this.set(!this.isEnabled)
  }

  /**
   * Enables the toggle.
   */
  @action.bound
  enable() {
    this.set(true)
  }

  /**
   * Disables the toggle.
   */
  @action.bound
  disable() {
    this.set(false)
  }

  /**
   * Sets the enabled state.
   *
   * @param enabled
   */
  @action.bound
  set(enabled: boolean) {
    this.isEnabled = enabled
  }
}
